module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no_data":"This report contains no data / urls."},"nl":{"no_data":"Dit rapport bevat geen gegevens."}}')
  delete Component.options._Ctor
}
